import Node from "./Node";

export enum GenealogyProviderType
{
    Invalid = 0,
    Wikitree = 1
}

export class GenealogyPerson
{
    // This is an enum because we need to support multiple providers.
    // It's a good idea to keep this on the results so that follow-up requests
    // (ancestors/descendants) know which provider to use for those requests.
    public provider_type : GenealogyProviderType = GenealogyProviderType.Wikitree;
    public id = '';
    /** full_name is the WikiTree id... we may want to refactor this for clarity */
    public full_name = '';
    public first_name = '';
    public middle_name = '';
    public last_name = '';
    public long_name = '';
    public birth_name = '';
    public gender = '';
    public is_alive = false;
    public birth_location = '';
    public birth_date : Date | null = null;
    public death_date : Date | null = null;
    public photo = '';
    public bio = '';
    public sources = '';

    public parents : GenealogyPerson[] = [];
    public children : GenealogyPerson[] = [];

    constructor(o : any)
    {
        this.provider_type = o.provider_type;
        this.id = o.id;
        this.full_name = o.full_name;
        this.first_name = o.first_name;
        this.middle_name = o.middle_name;
        this.last_name = o.last_name;
        this.long_name = o.long_name;
        this.birth_name = o.birth_name;
        this.gender = o.gender;
        this.is_alive = o.is_alive;
        this.birth_location = o.birth_location;
        this.birth_date = (o.birth_date) ? new Date(o.birth_date) : null;
        this.death_date = (o.death_date) ? new Date(o.death_date) : null;
        this.photo = o.photo;
        this.bio = o.bio;
        this.sources = o.sources;
        this.children = o.children.map((c : any) => new GenealogyPerson(c));
        this.parents = o.parents.map((p : any) => new GenealogyPerson(p));
    }
}

export function nodeToPerson(node: Node) : GenealogyPerson
{
    const gp = new GenealogyPerson({
        provider_type: ((node.data || {}) as any).genealogyProvider,
        id: ((node.data || {}) as any).genealogyId,
        full_name: ((node.data || {}) as any).genealogyName,
        long_name: node.name,
        birth_date: node.dateStart,
        death_date: node.dateEnd,
        photo: node.image,
        bio: node.description,
        sources: node.references,
        children: [],
        parents: [],
    });
    return gp;
}

export class GenealogyPersonSearchRequest
{
    public first_name = '';
    public last_name = '';
    // Birth date (YYYY-MM-DD) 
    public birth_date = '';
    // Death date (YYYY-MM-DD) 
    public death_date = '';
    // Birth location keyword(s) 
    public birth_location = '';
    // Death location keyword(s) 
    public death_location = '';

    public toRequestObject()
    {
        const req : any = {};
        Object.keys(this).forEach((key) =>
        {
            const val = (this as any)[key];
            if (val === '')
            {
                req[key] = undefined;
            }
            else
            {
                req[key] = val;
            }
        });
        return req;
    }
}